import RebookFlow from "../../Types/RebookFlow";
import BaseExperimentalFlowResolver from "./BaseExperimentalFlowResolver";
import ExperimentKey from "./ExperimentKey";
import NoConfirmationRebookFlow from "./NoConfirmationRebookFlow";

/** Resolves the no-confirmation rebook flow when the confirmation-page-removal experiment is active. */
class NoConfirmationRebookFlowResolver extends BaseExperimentalFlowResolver {
  constructor(isCustomerPreQualified: boolean, experimentKey: ExperimentKey) {
    super(new NoConfirmationRebookFlow(isCustomerPreQualified), new RebookFlow(isCustomerPreQualified), experimentKey);
  }
}

export default NoConfirmationRebookFlowResolver;
